import { combineReducers } from 'redux';

import genericSelectSlice from 'modules/global/reducers/generic.selectSlice';

import { createReducer } from 'utils/ReduxUtils';

import { FETCH_WORKS_TO_IMPORT, FETCH_WORKS_TO_IMPORT_SUCCESS } from './actionTypes';

export default combineReducers({
  ui: genericSelectSlice(FETCH_WORKS_TO_IMPORT),
  byId: createReducer({}, {
    [FETCH_WORKS_TO_IMPORT_SUCCESS]: (state, { payload }) => payload?.content?.reduce((acc, workItem) => ({
      ...acc,
      [workItem.id]: workItem
    }), state)
  })
});
